import styled from '@emotion/styled';
import { Colors, helperTypographyText, Variables, helperLinkReset } from '@utex/ui-kit';

export const Wrapper = styled('div')`
  ${helperTypographyText({
    size: 'M',
    lh: 'M',
  })};
  position: absolute;
  top: -3.5rem;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 4rem 4rem 3rem 3rem;
  color: ${Colors.text.default};
  background-color: ${Colors.ut.bgDefault};
  border-radius: 0 0 2rem 2rem;
  box-shadow: ${Variables.tooltipShadow};
  transition: opacity 0.4s, transform 0.4s;

  &.mount-enter {
    opacity: 0;
    transform: translateY(-3rem);
  }

  &.mount-enter-active,
  &.mount-exit {
    opacity: 1;
    transform: translateY(0);
  }

  &.mount-exit-active {
    opacity: 0;
    transform: translateY(-3rem);
  }
`;

export const Line = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  &:first-of-type {
    padding-bottom: 0.7rem;
    margin-bottom: 1.2rem;
    border-bottom: 1px solid ${Colors.ut.border10};
  }

  &:last-of-type {
    margin-bottom: 3rem;
  }
`;

export const Accounts = styled('a')`
  ${helperLinkReset};
  ${helperTypographyText({
    size: 'M',
    lh: 'M',
  })};
  color: ${Colors.text.primary};

  &:hover,
  &:focus {
    opacity: 0.5;
  }
`;
